<div class="fb-default-field-wrapper w-full">
  <div class="fb-field-label-container" *ngIf="!noLabel">
    <label
      class="fb-field-label"
      *ngIf="label"
      [class.disable-label]="formControl.disabled && (_currentThemeSubject | async) === 'dark'"
    >
      {{ label }}
      <span class="required-asterisk" *ngIf="required">*</span>
    </label>
  </div>

  <mat-form-field
    [appearance]="appearance || 'outline'"
    floatLabel="always"
    class="w-full date-picker-field fb-custom-outline"
    [class.is-invalid]="formControl.invalid && (formControl.touched || formControl.dirty)"
    [class.is-filled]="formControl.value"
  >
    <mat-label class="d-none"></mat-label>

    <input
      matInput
      [owlDateTimeTrigger]="rangePicker"
      [owlDateTime]="rangePicker"
      [selectMode]="'range'"
      [formControl]="formControl"
      fbDisableAutocomplete
      [placeholder]="placeholder || ''"
      [required]="required"
      [readonly]="true"
      min="{{ min !== undefined ? min : min }}"
      [max]="maxDate || undefined"
      [fbDisableControl]="disable"
      (focusout)="onTouched()"
      [class.dark-theme]="(_currentThemeSubject | async) === 'dark'"
      [class.light-theme]="(_currentThemeSubject | async) === 'light'"
      class="date-input"
    />

    <button
      *ngIf="formControl.value && !withNoResetDateRange"
      tabindex="-1"
      type="button"
      mat-icon-button
      matSuffix
      (click)="onClear(); $event.stopPropagation(); $event.preventDefault()"
      [disabled]="disable || readonly"
    >
      <mat-icon [inline]="true" class="icon-button">clear</mat-icon>
    </button>

    <mat-datepicker-toggle matPrefix tabindex="-1" [owlDateTimeTrigger]="rangePicker" class="date-picker-toggle">
      <mat-icon
        matDatepickerToggleIcon
        class="c-pointer picker-toggle icon-button"
        [class.dark-theme]="(_currentThemeSubject | async) === 'dark'"
        [class.light-theme]="(_currentThemeSubject | async) === 'light'"
        [svgIcon]="'fleet-management'"
      >
      </mat-icon>
    </mat-datepicker-toggle>

    <owl-date-time
      [pickerType]="'calendar'"
      #rangePicker
      [panelClass]="[
        'green-theme-picker',
        'range-date-picker-mode',
        (_currentThemeSubject | async) === 'dark' ? 'darkPicker' : 'lightPicker'
      ]"
    >
    </owl-date-time>
  </mat-form-field>

  <div class="fb-field-subscript">
    <fb-validation-error
      *ngIf="formControl.invalid && (formControl.touched || formControl.dirty)"
      [control]="formControl"
      [label]="label"
    ></fb-validation-error>
  </div>
</div>
